<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="300"
    min-width="550px"
    max-width="880px"
    max-height="800px"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        outlined
        v-bind="attrs"
        v-on="on"
        class="mx-0 px-0"
        style="min-width: 30px !important"
      >
        <v-icon dense>mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-card outlined>
      <v-card-title class="font-weight-medium"
        ><span class="text-subtitle-1 font-weight-medium"
          >Personalakte wechseln</span
        >
        <v-spacer></v-spacer>
        <v-btn icon small @click="close()"
          ><v-icon small>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-subtitle>
        <v-text-field
          v-model="search"
          outlined
          dense
          label="Suchen"
          hide-details="auto"
          prepend-inner-icon="mdi-magnify"
          class="mt-2"
          clearable
        ></v-text-field>
        <v-select
          v-model="statusFilter"
          :items="statusValues"
          label="Nach Status filtern"
          outlined
          multiple
          dense
          required
          item-text="text"
          item-value="value"
          prepend-inner-icon="mdi-filter"
          hide-details="auto"
          class="mt-3"
        >
          <template v-slot:selection="data">
            <personnel-record-status-chip
              :status="data.item.value"
              small
              class="mr-1"
              @click="toggle"
            >
            </personnel-record-status-chip>
          </template>
        </v-select>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="listItems"
        :search="search"
        item-key="uid"
        sort-by="lastName"
        fixed-header
        height="500"
        group-by="groupByDivision"
        dense
        checkbox-color="primary"
        mobile-breakpoint="0"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:[`group.header`]="{ items, isOpen, toggle }">
          <th :colspan="headers.length++">
            <v-icon @click="toggle" class="mr-2"
              >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
            <span>
              {{ stripPrefix(items[0].groupByDivision) }}
            </span>
          </th>
        </template>
        <template v-slot:[`item.personnelNumber`]="{ item }">
          <pre>{{ item.personnelNumber }}</pre>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <personnel-record-status-chip :status="item.status" small>
          </personnel-record-status-chip>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <!-- Navigation mode: Show current/open buttons -->
          <template v-if="enableNavigation">
            <span v-if="item.user.membershipId == $route.params.itemId">
              <v-btn
                color="primary"
                x-small
                depressed
                label
                read-only
                class="font-weight-medium mr-1"
                >Bereits aktiv</v-btn
              >
              <v-tooltip bottom v-if="!enableSplitView">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    depressed
                    @click="openInSplitView(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-view-split-vertical</v-icon>
                  </v-btn>
                </template>
                <span>In geteilter Ansicht öffnen</span>
              </v-tooltip>
            </span>
            <span v-else>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    depressed
                    @click="startRoute(item)"
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-open-in-app</v-icon>
                  </v-btn>
                </template>
                <span>Öffnen</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    depressed
                    @click="startRoute(item, 'newTab')"
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>In neuem Tab öffnen</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!enableSplitView">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    depressed
                    @click="openInSplitView(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-view-split-vertical</v-icon>
                  </v-btn>
                </template>
                <span>In geteilter Ansicht öffnen</span>
              </v-tooltip>
            </span>
          </template>

          <!-- Selection mode: Show select/selected buttons -->
          <template v-else>
            <v-btn
              v-if="item.user.membershipId === selectedRecordId"
              color="primary"
              x-small
              depressed
              label
              read-only
              class="font-weight-medium"
              >Ausgewählt</v-btn
            >
            <v-btn
              v-else
              x-small
              depressed
              @click="selectRecord(item)"
              color="primary"
              outlined
            >
              Auswählen
            </v-btn>
          </template>
        </template></v-data-table
      >
    </v-card>
  </v-menu>
</template>

<style></style>

<script>
import PersonnelRecordStatusChip from "@/components/member-management/personnel-records/PersonnelRecordStatusChip.vue";
import { PERSONNEL_STATUS_OPTIONS } from "@/util/personnel-records.js";
export default {
  name: "person-switcher-selector-menu",
  props: {
    selection: {},
    items: {},
    // When true, handles navigation via router. When false, just emits selection events
    enableNavigation: {
      type: Boolean,
      default: true,
    },
    // The currently selected record ID (for v-model support)
    value: {
      type: String,
      default: null,
    },
    // Enable split-view actions (adds split-view button)
    enableSplitView: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  components: { PersonnelRecordStatusChip },
  computed: {
    selectionLocal: {
      get: function () {
        return this.selection;
      },
      set: function (value) {
        this.$emit("selectionChange", value);
      },
    },
    // Current selected record ID (for v-model support)
    selectedRecordId() {
      return this.value;
    },
    listItems() {
      return this.items
        .map((record) => {
          return {
            ...record,
            groupByDivision:
              (record.division?.sortKey?.toString().padStart(4, "0") ||
                "0000") +
              "_" +
              (record.division?.title || "Keine Einheit"),
          };
        })
        .filter((record) => {
          return this.statusFilter.includes(record.status);
        });
    },
    defaultHeaders() {
      return this.headers.filter((header) => header.default);
    },
    defaultState() {
      return (
        this.selectionLocalBuffer.length === this.defaultHeaders.length &&
        this.selectionLocalBuffer.every((item) => item.default)
      );
    },
  },
  data() {
    return {
      menu: false,
      search: "",
      statusFilter: ["active", "onLeave", "transfer"],
      selectionLocalBuffer: [],
      statusValues: PERSONNEL_STATUS_OPTIONS,
      headers: [
        {
          text: "Personalnr.",
          value: "personnelNumber",
          align: "start",
        },
        {
          text: "Vorname",
          value: "firstName",
          align: "start",
        },
        {
          text: "Nachname",
          value: "lastName",
          align: "start",
          divider: true,
        },
        {
          text: "Status",
          value: "status",
          align: "start",
          divider: true,
        },
        {
          text: "",
          value: "action",
          align: "right",
        },
      ],
    };
  },
  created() {
    this.selectionLocalBuffer = this.selectionLocal;
  },
  methods: {
    close() {
      this.menu = false;
    },
    stripPrefix(item) {
      return item.substring(item.indexOf("_") + 1);
    },
    startRoute(item, newTab) {
      if (this.enableNavigation) {
        // Original navigation behavior
        if (newTab) {
          window.open(
            this.$router.resolve({
              name: this.$router.currentRoute.name,
              params: {
                ...this.$router.currentRoute.params,
                itemId: item.user.membershipId,
              },
            }).href,
            "_blank"
          );
        } else {
          this.$router.push({
            name: this.$router.currentRoute.name,
            params: {
              ...this.$router.currentRoute.params,
              itemId: item.user.membershipId,
            },
          });
        }
      } else {
        // Selection mode - emit the selection without navigation
        this.selectRecord(item);
      }
      this.close();
    },
    selectRecord(item) {
      // Emit the selected record ID for v-model support
      this.$emit("input", item.user.membershipId);
      // Also emit the full item for backward compatibility
      this.$emit("selectionChange", item.user.membershipId);
      // Emit the full record object if needed
      this.$emit("record-selected", item);
    },
    openInSplitView(item) {
      // Navigate to split view route with query parameters
      const currentRoute = this.$router.currentRoute;

      // The selected person becomes the primary pane
      // Secondary pane is left empty for user to select
      const selectedPersonId = item.user.membershipId;

      const newQuery = {
        primary: selectedPersonId,
        // secondary is intentionally omitted - will be empty
      };

      this.$router.push({
        name: "member-management-personnel-records-split-screen",
        params: {
          organizationId: currentRoute.params.organizationId,
        },
        query: newQuery,
      });

      this.close();
    },
  },
};
</script>
